export const formatNumber = (number, forms, includeNumber = false) => {
    let cases = [2, 0, 1, 1, 1, 2];
    const title = forms[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
    return includeNumber ? `${number} ${title}` : title;
}

export const uniqueId = () => {
    return Math.random().toString(36).slice(2)
}

// Функция расчета расстояния Левенштейна
export const levenshteinDistance = (a, b) => {
    const matrix = [];
    for (let i = 0; i <= b.length; i++) matrix[i] = [i];
    for (let j = 0; j <= a.length; j++) matrix[0][j] = j;

    for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
            if (b.charAt(i - 1) === a.charAt(j - 1)) {
                matrix[i][j] = matrix[i - 1][j - 1];
            } else {
                matrix[i][j] = Math.min(
                    matrix[i - 1][j - 1] + 1,
                    Math.min(
                        matrix[i][j - 1] + 1,
                        matrix[i - 1][j] + 1
                    )
                );
            }
        }
    }
    return matrix[b.length][a.length];
};

// Нормализация (убирает акценты)
export const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};
